module.exports = __webpack_public_path__ + "img/qq.bc06a31f.svg";